import { Fragment } from 'react';

import Divider from '@zenbusiness/zui/Divider';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import { MenuItemStyled } from './SettingOptions.styles';

export default function SettingOptions({ options, handleSelectItem }) {
  const handleClose = (key, event) => {
    handleSelectItem(key, event);
  };

  const visibleOptions = options.filter(({ hidden }) => !hidden);
  const menuItems = visibleOptions.map(({ key, name, disabled }, index) => (
    <Fragment key={name}>
      <MenuItemStyled
        disabled={disabled}
        onClick={(event) => handleClose(key, event)}
      >
        {name}
      </MenuItemStyled>
      {index < visibleOptions.length - 1 && <Divider />}
    </Fragment>
  ));

  return <Stack role="list">{menuItems}</Stack>;
}

SettingOptions.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      disabled: PropTypes.bool
    })
  ).isRequired,
  handleSelectItem: PropTypes.func.isRequired
};
